import React, { useContext, useEffect, useState } from "react";
import style from "../style/VerificationCode.module.scss";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { LoginContext } from "../contexts/LoginContext";
import { useMutation } from "react-query";
import CountDown from "../components/CountDown";
import { Link } from "react-router-dom";
import apiClient from "../libraries/ApiClient";

const CssTextField = styled(TextField)({
  "& label.Mui-error": {
    color: "#EB4D3D",
  },
  "& .MuiOutlinedInput-root": {
    "&.Mui-error fieldset": {
      borderColor: "#EB4D3D",
    },
  },
});

const CssButton = styled(Button)({
  fontSize: 16,
  background: "#057AFF",
  "&:disabled": {
    border: "1px solid #818181",
    color: "#818181",
    background: "#E0E0E0",
  },
  "&:hover": {
    cursor: "pointer",
  },
});

function VerificationCode() {
  const codeRule = /^-?\d*\.?\d*$/;
  const navigate = useNavigate();

  const { mailValue } = useContext(LoginContext);
  const { phoneValue } = useContext(LoginContext);

  const [code, setCode] = useState("");
  const [vaild, setVaild] = useState(false);

  const [timeLeft, setTimeLeft] = useState(180); // 180 seconds = 3 minutes
  const [isRunning, setIsRunning] = useState(true);

  const onChangeCodeValue = (e) => {
    const value = e.target.value;
    const vaildateValue = (value) => codeRule.test(value);
    // console.log(vaildateValue(value));
    // console.log(value);
    let a = value.split("");

    if (vaildateValue(value) && a.length <= 4) {
      setCode(e.target.value);
    }
    if (a.length === 4) {
      setVaild(true);
    }
  };

  const sendCodeData = async ({ mailValue, phoneValue, code }) => {
    const data = {
      Data: {
        Identifier: mailValue,
        Phone: phoneValue,
        OtpCode: code,
      },
    };

    const res = await apiClient.postAes(
      "api/otp/validation/forgotpwd/Security",
      data
    );

    return res?.data?.Code;
  };
  const sendMailVerData = async ({ mailValuem, phoneValue }) => {
    const data = {
      Data: {
        Identifier: mailValue,
        Phone: phoneValue,
      },
    };

    const res = await apiClient.postAes(
      "api/otp/send/forgotpwd/Security",
      data
    );

    return res?.data?.Code;
  };

  const {
    data: ResData,
    mutate: sendCodeMutate,
    isLoading,
  } = useMutation(sendCodeData);

  const { data: ResMailData, mutate: sendMailMutate } =
    useMutation(sendMailVerData);

  //console.log(ResData);

  useEffect(() => {
    if (+ResData === 0) {
      alert("驗證成功");
      navigate("/ResetPassword");
    } else if (+ResData === 1) {
      alert("驗證碼錯誤");
      return;
    }
  }, [ResData]);
  useEffect(() => {
    if (+ResMailData === 0) {
      alert("已重新發送");
    }
  }, [ResMailData]);

  return (
    <div className={style.VerificationCode_body}>
      <div className={style.VerificationCode_background}></div>
      <svg
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 1921 273"
        className={style.triangle}
      >
        <polygon fill="#fff" points="0,273 1921,273 1921,0 "></polygon>
      </svg>
      <div className={style.VerificationCode_form_body}>
        <div className={style.logo}>
          <img src="/end_logo.svg" alt="" style={{ width: "20%" }} />
        </div>
        <div className={style.VerificationCode_form}>
          <div className={style.VerificationCode_form_top}>
            <div className={style.VerificationCode_title}>請輸入驗證碼</div>
            <div className={style.VerificationCode_little_title}>
              {mailValue != "" && phoneValue != ""
                ? `系統已將驗證碼寄到${mailValue} && ${phoneValue}`
                : ""}
              {mailValue == "" && phoneValue != ""
                ? `系統已將驗證碼寄到${phoneValue}`
                : ""}
              {mailValue != "" && phoneValue == ""
                ? `系統已將驗證碼寄到${mailValue}`
                : ""}
            </div>
          </div>
          <div className={style.input_content}>
            <div className={style.input_mail}>
              <CssTextField
                label="請輸入驗證碼(4碼數字)"
                variant="outlined"
                onChange={onChangeCodeValue}
                value={code}
                // error={hasMailError ? true : false}
                style={{ width: "100%" }}
              />
            </div>
            <div className={style.btn}>
              <CssButton
                variant="contained"
                onClick={() => {
                  sendCodeMutate({ mailValue, phoneValue, code });
                }}
                disabled={!vaild || isLoading}
              >
                下一步
              </CssButton>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "14px",
                }}
              >
                您還沒收到驗證碼嗎?
                {timeLeft === 0 && (
                  <div
                    style={{
                      textDecoration: "none",
                      color: "#057AFF",
                      textAlign: "center",
                      padding: "16px",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      sendMailMutate({ mailValue, phoneValue });
                      setIsRunning(true);
                      setTimeLeft(10);
                    }}
                  >
                    再次發送驗證碼
                  </div>
                )}
                <CountDown
                  setTimeLeft={setTimeLeft}
                  setIsRunning={setIsRunning}
                  isRunning={isRunning}
                  timeLeft={timeLeft}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerificationCode;
